<template>
  <button class="@container size-full flex items-center">
    <div
      class="w-full px-3 py-2 flex flex-col items-center justify-center rounded-lg bg-white"
      :class="isActive ? 'group active font-secondary h-full border-4 border-blue' : 'min-h-[108px]'"
    >
      <span
        class="-mt-0.5 group-[.active]:font-bold"
      >
        {{ year }}
      </span>
      <strong class="uppercase">
        {{ month }}
      </strong>

      <div
        class="flex flex-col"
      >
        <span
          v-if="isDiscounted"
          class="strikethrough mx-auto leading-4 mt-1"
        >
          {{ $n(originalPrice) }}
        </span>

        <div :class="{ 'text-discounted': isDiscounted }">
          <span
            v-if="!isDiscounted"
            class="text-sm font-secondary"
          >
            {{ $t('shortFromPrice') }}
          </span>
          <strong class="font-bold">
            {{ $n(price) }}
          </strong>
        </div>
      </div>
    </div>
  </button>
</template>

<script setup lang="ts">
import type { Month } from './types'

type Props = Month & {
  isActive?: boolean
}

const props = defineProps<Props>()

const dayjs = useDayjs()

const year = computed(() => dayjs(props.date).format('YYYY'))

const month = computed(() => dayjs(props.date).format('MMM'))

const isDiscounted = computed(() => props.originalPrice && props.price !== props.originalPrice)
</script>